export enum ContactsEvents {
    userAddedContactRole = 'user_added_contact_role',
    userUpdatedContact = 'user_updated_contact',
    userCreatedContact = 'user_created_contact',
    userAddedHorse = 'user_added_horse_to_contact',
    userDeletedContact = 'user_deleted_contact',
    userUsedContactsSearchBar = 'user_used_contacts_search_bar',
    userAddedContactFromContactsBook = 'user_added_contact_from_contacts_book',
}
